import styled, { css } from 'styled-components/macro';
import { colorCoreBlack900Base, colorBlackTransparent100, colorCoreWhite1000, colorWhiteTransparent300, } from '@yme/tokens/colors';
export const DotsStyled = styled.div `
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
`;
const SVGCircleDark = css `
  ${({ isActive = false }) => (isActive ? colorCoreWhite1000 : colorWhiteTransparent300)};
`;
const SVGCircleLight = css `
  ${({ isActive = false }) => (isActive ? colorCoreBlack900Base : colorBlackTransparent100)};
`;
export const SVGIconStyled = styled.span `
  margin: 0 3px;

  svg {
    rect {
      fill: ${({ isLightTheme }) => (isLightTheme ? SVGCircleLight : SVGCircleDark)};
    }
  }

  display: ${({ isVisibleItem }) => !isVisibleItem && 'none'};
`;
export const SVGIconInfinityStyled = styled(SVGIconStyled) `
  display: flex;
  align-items: center;

  ${({ isPositionStart }) => (isPositionStart ? 'left: -6px;' : 'right: -6px;')};

  ${({ isDotsFixed }) => isDotsFixed &&
    css `
      position: absolute;
      top: 0;
      bottom: 0;
      margin: 0px;
    `};

  display: ${({ isVisibleItem }) => !isVisibleItem && 'none'};
`;
